import {Heading, VStack} from 'platform/foundation';

import i18n from '@dms/i18n';

import {CoolantFluidReplacementGroup} from '../../kit/groups/CoolantFluidReplacementGroup';
import {VehicleForm as VFKit} from '../../kit/VehicleForm';

export function CoolantFluidReplacementSubSection() {
  return (
    <>
      <VFKit.SubSection data-testid="coolant-fluid-replacement">
        <VStack spacing={4}>
          <Heading size={4}>{i18n.t('entity.vehicle.labels.coolantFluid')}</Heading>
          <VFKit.Group columns={4} data-testid="coolant-fluid-replacement-group">
            <CoolantFluidReplacementGroup />
          </VFKit.Group>
        </VStack>
      </VFKit.SubSection>
    </>
  );
}
